<article class="col-start-center text-center px-4 py-3 rounded-lg border border-[var(--p-surface-200)] bg-[var(--p-surface-0)] shadow-sm h-full">
  <div class="row-start-center gap-1.5 text-[var(--p-text-muted-color)]">
    @if (icon()) {
      <i [class]="icon()" style="font-size: 0.75rem"></i>
    }
    <span class="text-[10px] font-semibold uppercase tracking-wider">{{ label() }}</span>
  </div>
  <span class="mt-1.5 text-2xl font-bold tabular-nums leading-none inline-flex items-center gap-1.5" [style.color]="toneColor()">
    @if (toneArrow(); as arrow) {
      <i [class]="arrow" style="font-size: 1rem"></i>
    }
    {{ value() }}
  </span>
  @if (unit()) {
    <span class="mt-0.5 text-[10px]" [style.color]="tone() === 'default' ? 'var(--p-text-muted-color)' : toneColor()">
      {{ unit() }}
    </span>
  }
</article>
